import styled from 'styled-components';

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  margin-bottom: 1rem;
`;

export const SelectLabel = styled.label`
  margin-bottom: 0.5rem;
  font-weight: bold;
`;

export const SelectStyled = styled.div`
  position: relative;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #fff;
  padding: 0.5rem;
  font-size: 1rem;
  width: 100%;
  cursor: pointer;
  box-sizing: border-box;
`;

export const SelectedValue = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const OptionsList = styled.ul`
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: white;
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 150px;
  overflow-y: auto;
  z-index: 1000;
`;

export const OptionItem = styled.li`
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;

export const Arrow = styled.span`
  border: solid #333;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: ${(props) => (props.$isOpen ? 'rotate(-135deg)' : 'rotate(45deg)')};
  transition: transform 0.2s ease;
`;
